/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from 'react'
import { Pagination } from 'antd'
import { useSelector } from 'react-redux'

const perPage = 10

const RecordPagination = ({ onSelected }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const cloudRecords = useSelector(state => state.cloudRecords)
  const recordsList = cloudRecords.cloud_records;

  const setPagenition = (page) => {
    setCurrentPage(page)
    onSelected({page, perPage})
  }

  useEffect(() => {
    if(recordsList.length === 0 && currentPage !== 1) {
      const prevPage = currentPage - 1
      setPagenition(prevPage)
    }
    return () => {}
  }, [recordsList])

  return (
    <div>
      <Pagination 
        onChange={setPagenition} 
        current={currentPage} 
        pageSize={perPage} 
        total={cloudRecords.total} 
        showSizeChanger={false} />
    </div>
  )
}

export default RecordPagination
